import { render, staticRenderFns } from "./ContestRequirementListComponent.vue?vue&type=template&id=ba883a50"
import script from "./ContestRequirementListComponent.vue?vue&type=script&lang=js"
export * from "./ContestRequirementListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports